import type { MarketingPreferencesResponse } from '../types';
import axiosInstance from './axiosInstance';

export async function fetchMarketingPreferences(
  getToken: () => Promise<string>,
): Promise<MarketingPreferencesResponse> {
  const token = await getToken();
  const response = await axiosInstance.get<MarketingPreferencesResponse>('/marketing/preferences', {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
}

export async function setMarketingPreference(
  getToken: () => Promise<string>,
  slug: string,
  subscribed: boolean,
): Promise<void> {
  const token = await getToken();
  await axiosInstance.put(
    `/marketing/preferences/${encodeURIComponent(slug)}`,
    { subscribed },
    { headers: { Authorization: `Bearer ${token}` } },
  );
}

export async function completeMarketingOnboarding(
  getToken: () => Promise<string>,
  selectedSlugs: string[],
): Promise<void> {
  const token = await getToken();
  await axiosInstance.post(
    '/marketing/onboarding',
    { selectedSlugs },
    { headers: { Authorization: `Bearer ${token}` } },
  );
}
